import { render, staticRenderFns } from "./ChipAvatar.vue?vue&type=template&id=4c0ee4d3&scoped=true"
import script from "./ChipAvatar.vue?vue&type=script&lang=js"
export * from "./ChipAvatar.vue?vue&type=script&lang=js"
import style0 from "./ChipAvatar.vue?vue&type=style&index=0&id=4c0ee4d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ee4d3",
  null
  
)

export default component.exports